import { Component } from '@angular/core';
import { CellRendererComponent } from "@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive";
import { Column } from "@valg-shared/components/table/table/column";
import { DateTimeService } from '@valg-shared/services/date-time-service/date-time.service';
import { getValueAt } from "@valg-shared/utils/object-utils";
import { ColumnMetadata } from '../../table/column-metadata';

@Component({
  selector: 'valg-date-renderer',
  templateUrl: './date-time-renderer.component.html',
})
export class DateTimeRendererComponent implements CellRendererComponent {

  public value: Date | undefined;
  public transformedValue!: string | null;
  public metadata?: ColumnMetadata;

  constructor(
    private readonly dateTimeService: DateTimeService
  ) { }

  public init(data: string, column: Column): void {
    this.value = getValueAt(data, column.path);
    this.metadata = column.metadata;
    if(this.metadata?.format) {
      this.transformedValue = this.dateTimeService.datePipeTransformDate(this.value!, this.metadata?.format);
      return;
    }
    if(this.value){
      this.transformedValue = this.dateTimeService.datePipeTransformDateTime(this.value);
    }
  }
}
